<div class="estadisticas-uso">
  <!-- Barra de filtros: período global y exportación -->
  <app-dashboard-filtros titulo="Estadísticas de uso">
    <app-date-picker
      filtros-periodo
      mode="daterange"
      label="Período"
      [maxDate]="hoy"
      [(ngModel)]="rango"
      (ngModelChange)="onRangoChange()"
    ></app-date-picker>
    <button
      irxBotonIcono
      filtros-acciones
      tooltip="Exportar"
      aria-label="Exportar"
      (click)="exportar()"
      [disabled]="exportando || cargandoUsuarios"
    >
      <mat-icon>file_download</mat-icon>
    </button>
  </app-dashboard-filtros>

  <!-- Tarjetas de indicador -->
  <div class="eu-cards dashboard-indicadores">
    @for (t of tarjetas; track t.campo) {
      <app-stat-card
        [title]="t.titulo"
        [icon]="t.icono"
        color="primary"
        [value]="cargandoResumen ? '…' : (resumen?.[t.campo] ?? 0)"
        [formatAsNumber]="true"
        numberFormat="1.0-0"
      ></app-stat-card>
    }
  </div>

  <!-- Serie temporal -->
  <app-chart-card
    title="Actividad diaria"
    icon="show_chart"
    variante="panel"
    [chartOptions]="chartOptions"
    [sinDatos]="
      !cargandoSerie && !serie.length
        ? 'Sin actividad en el período seleccionado.'
        : null
    "
    chartHeight="320px"
  ></app-chart-card>

  <!-- Agregado por cliente -->
  <app-dashboard-panel titulo="Actividad por cliente" icono="business">
    @if (cargandoClientes) {
      <div class="dpanel-vacio">
        <mat-spinner diameter="36"></mat-spinner>
        <p>Cargando clientes…</p>
      </div>
    } @else if (!porCliente.length) {
      <div class="dpanel-vacio">
        <mat-icon>business</mat-icon>
        <p>Sin actividad de clientes en el período seleccionado.</p>
      </div>
    } @else {
      <div class="eu-table-scroll">
        <table mat-table [dataSource]="porCliente" class="eu-table">
          <ng-container matColumnDef="cliente">
            <th mat-header-cell *matHeaderCellDef>Cliente</th>
            <td mat-cell *matCellDef="let c">
              @if (c.nombre) {
                {{ c.nombre }}
              } @else {
                <span class="no-info">Sin cliente</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="nivel">
            <th mat-header-cell *matHeaderCellDef>Nivel</th>
            <td mat-cell *matCellDef="let c">
              @if (c.nivel != null) {
                {{ c.nivel }}
              } @else {
                <span class="no-info">Sin nivel</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="logins">
            <th mat-header-cell *matHeaderCellDef>Logins</th>
            <td mat-cell *matCellDef="let c">
              @if (c.totalLogins != null) {
                {{ c.totalLogins | number: '1.0-0' }}
              } @else {
                <span class="no-info">Sin dato</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="activos">
            <th mat-header-cell *matHeaderCellDef>Usuarios activos</th>
            <td mat-cell *matCellDef="let c">
              @if (c.usuariosActivos != null) {
                {{ c.usuariosActivos | number: '1.0-0' }}
              } @else {
                <span class="no-info">Sin dato</span>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnasClientes"></tr>
          <tr mat-row *matRowDef="let row; columns: columnasClientes"></tr>
        </table>
      </div>
    }
  </app-dashboard-panel>

  <!-- Detalle por usuario -->
  <app-dashboard-panel
    class="eu-panel-usuarios"
    titulo="Detalle por usuario"
    icono="person"
  >
    <!-- Filtros de la tabla (no afectan resumen/serie/por-cliente) -->
    <app-cliente-selector
      panel-acciones
      class="eu-filtro-cliente"
      placeholder="Filtrar por cliente"
      [clearable]="true"
      [includeChildren]="true"
      (clienteIdChange)="onFiltroClienteChange($event)"
    ></app-cliente-selector>
    <mat-form-field panel-acciones appearance="outline" class="eu-buscar">
      <mat-label>Buscar usuario o nombre</mat-label>
      <input
        matInput
        [(ngModel)]="busqueda"
        (ngModelChange)="onBusquedaChange()"
        placeholder="Ej: san-rafael"
      />
      @if (busqueda) {
        <button
          irxBotonIcono
          matSuffix
          aria-label="Limpiar"
          (click)="busqueda = ''; onBusquedaChange()"
         tooltip="Limpiar">
          <mat-icon>close</mat-icon>
        </button>
      } @else {
        <mat-icon matSuffix>search</mat-icon>
      }
    </mat-form-field>

    @if (cargandoUsuarios) {
      <div class="dpanel-vacio">
        <mat-spinner diameter="36"></mat-spinner>
        <p>Cargando usuarios…</p>
      </div>
    } @else if (!usuarios.length) {
      <div class="dpanel-vacio">
        <mat-icon>person</mat-icon>
        <p>No hay usuarios para el período y los filtros seleccionados.</p>
      </div>
    } @else {
      <div class="eu-table-scroll">
        <table mat-table [dataSource]="usuarios" class="eu-table">
          <ng-container matColumnDef="usuario">
            <th mat-header-cell *matHeaderCellDef>Usuario</th>
            <td mat-cell *matCellDef="let u">
              <div class="eu-usuario">
                <span class="eu-usuario-nombre">{{ u.usuario }}</span>
                @if (u.nombre) {
                  <span class="eu-usuario-sub">{{ u.nombre }}</span>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="cliente">
            <th mat-header-cell *matHeaderCellDef>Cliente</th>
            <td mat-cell *matCellDef="let u">
              @if (u.clienteNombre) {
                {{ u.clienteNombre }}
              } @else {
                <span class="no-info">Sin cliente</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="ultimoLogin">
            <th mat-header-cell *matHeaderCellDef>Último login</th>
            <td mat-cell *matCellDef="let u">
              @if (u.ultimoLogin) {
                <span class="eu-usuario">
                  <span>{{ fechaCelda(u.ultimoLogin) }}</span>
                  <span class="eu-usuario-sub">{{ haceCelda(u.ultimoLogin) }}</span>
                </span>
              } @else {
                Nunca
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="diasDesde">
            <th mat-header-cell *matHeaderCellDef>Días sin actividad</th>
            <td mat-cell *matCellDef="let u">
              @if (u.diasDesdeUltimoLogin != null) {
                {{ u.diasDesdeUltimoLogin }}
              } @else {
                <span class="no-info">Sin ingresos</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="loginsTotales">
            <th mat-header-cell *matHeaderCellDef>Logins totales</th>
            <td mat-cell *matCellDef="let u">
              @if (u.cantidadLogins != null) {
                {{ u.cantidadLogins | number: '1.0-0' }}
              } @else {
                <span class="no-info">Sin dato</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="loginsRango">
            <th mat-header-cell *matHeaderCellDef>Logins del período</th>
            <td mat-cell *matCellDef="let u">
              @if (u.loginsRango != null) {
                {{ u.loginsRango | number: '1.0-0' }}
              } @else {
                <span class="no-info">Sin dato</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="diasActivos">
            <th mat-header-cell *matHeaderCellDef>Días activos</th>
            <td mat-cell *matCellDef="let u">
              @if (u.diasActivosRango != null) {
                {{ u.diasActivosRango | number: '1.0-0' }}
              } @else {
                <span class="no-info">Sin dato</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="racha">
            <th mat-header-cell *matHeaderCellDef>Racha</th>
            <td mat-cell *matCellDef="let u">
              @if (u.rachaActual != null) {
                {{ u.rachaActual | number: '1.0-0' }}
              } @else {
                <span class="no-info">Sin dato</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="plataformas">
            <th mat-header-cell *matHeaderCellDef>Plataformas</th>
            <td mat-cell *matCellDef="let u">
              @if (u.plataformas?.length) {
                {{ u.plataformas.join(', ') }}
              } @else {
                <span class="no-info">Sin plataformas</span>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnasUsuarios"></tr>
          <tr mat-row *matRowDef="let row; columns: columnasUsuarios"></tr>
        </table>
      </div>
      <mat-paginator
        [length]="totalUsuarios"
        [pageSize]="limit"
        [pageIndex]="page"
        [pageSizeOptions]="helper.pageSizeOptions"
        (page)="onPage($event)"
        showFirstLastButtons
      ></mat-paginator>
    }
  </app-dashboard-panel>
</div>
